'use strict';

angular.module( 'angus.directives' ).directive( 'bsgServiceMargin', [
	'actionViewTemplates',
	function( actionViewTemplates ) {
		return {
			scope: {
				model: '=actionModel',
				settings: '=bsgServiceMarginWidgetSettings',
				widgetCode : '='
			},
			templateUrl: actionViewTemplates.bsgServiceMarginActionView
		};
	}
] );